import * as React from 'react';

import { translate } from '~l10n/client';

import { PaywallScreens } from '~analytics/types';
import { UIButton } from '~shared/components/buttons';
import { DialogProps } from '~shared/components/Dialog';
import {
  PaywallDialog,
  PaywallUpgradeButton,
} from '~teacher/components/PaywallDialog';

export type Props = Pick<DialogProps, 'open' | 'onClose'>;

export function PauseActivityPaywall({ open, onClose, ...props }: Props) {
  return (
    <PaywallDialog.Short
      id="pause-activity-paywall"
      open={open}
      onClose={onClose}
      title={translate('Upgrade to Pause Activity')}
      actions={[
        <UIButton key="cancel" onClick={onClose}>
          {translate('Cancel')}
        </UIButton>,
        <PaywallUpgradeButton
          key="upgrade"
          appearance="primary"
          paywallScreen={PaywallScreens.PauseActivity}
        />,
      ]}
      closeLabel={translate('Close')}
      {...props}
      paywallTouch={[PaywallScreens.PauseActivity]}
    >
      <p className="m-0 pb-4 text-blue-900">
        {translate(
          'Pause student responses and hide questions until ready to resume.'
        )}
      </p>
    </PaywallDialog.Short>
  );
}
